import React from 'react';

import classnames from 'classnames';
import { Card, CardHeader } from '@andes/card';

import { CollapsibleCardPropTypes } from './propTypes';
import { UI_SEARCH_COLLAPSIBLE_CARD_NAMESPACE as namespace } from '../../constants';
import { withComponentHandler } from '../../hocs/with-component-handler';
import CollapsibleCardHeader from './collapsible-card-header';
import CollapsibleCardContent from './collapsible-card-content';

/**
 * @typedef {Object} CollapsibleCardProps
 * @property {string} title - The title text to display in the card header
 * @property {string} content - The HTML content to be displayed in the card
 * @property {boolean} [isExpanded=false] - Whether the card is expanded or not
 * @property {Function} onClick - Callback function to handle click events on the card header
 */

/**
 * CollapsibleCard component renders a card that can be expanded or collapsed.
 * It consists of a header with a title and an expand/collapse button, and a content section
 * that shows or hides based on the expanded state.
 *
 * @param {CollapsibleCardProps} props - The props for the component
 * @returns {JSX.Element} A Card component containing a header and collapsible content
 */
const CollapsibleCard = ({ title, content, isExpanded = false, onClick }) => (
  <Card className={classnames(namespace)} shadow="outline" paddingSize="0" data-testid="collapsible-card">
    <CardHeader className={classnames(`${namespace}__header`)}>
      <CollapsibleCardHeader title={title} onClick={onClick} isExpanded={isExpanded} />
    </CardHeader>
    <CollapsibleCardContent content={content} isExpanded={isExpanded} />
  </Card>
);

CollapsibleCard.propTypes = {
  ...CollapsibleCardPropTypes,
};

export default withComponentHandler(CollapsibleCard, { componentName: 'CollapsibleCard' });
